<ds-modal #tpl [ds-modal-trigger-for]="tpl" [isModalOpen]="visible"
          (dismiss)="close()">
  <ds-box-header>{{ 'customer.selectCustomer' | translate }}</ds-box-header>

  <ds-box-content>
    <p>{{ 'customer.multipleCustomersFound' | translate }}</p>

    @for (customer of customerList; track customer.dmsCustomerId) {
      <ds-box class="my-3x">
        <ds-box-content class="container-fluid" [isClickable]="true" (boxClick)="customerSelected(customer)">
          <div class="row">
            <div class="col">
              <div class="text-label">{{ 'customer.name' | translate }}</div>
              <div>{{ getCustomerDisplayName(customer) }}</div>
            </div>
            <div class="col">
              <div class="text-label">{{ 'customer.dmsCustomerId' | translate }}</div>
              <div>{{ customer.dmsCustomerId }}</div>
            </div>
            <div class="col">
              <div class="text-label">{{ 'customer.relationType.label' | translate }}</div>
              <div>{{ 'customer.relationType.' + customer.relationType | translate }}</div>
            </div>
            @if (customer.gcdmCustomerId) {
              <div class="col">
                <div class="text-label">{{ 'customer.gcdmCustomerId' | translate }}</div>
                <div>{{ customer.gcdmCustomerId }}</div>
              </div>
            }
          </div>
        </ds-box-content>
      </ds-box>
    }
  </ds-box-content>

  <ds-box-footer>
    <button ds-button variant="outline" (click)="close()">{{ 'common.cancel' | translate }}</button>
  </ds-box-footer>
</ds-modal>

